export default function htmlEscape(text = ''){
  text = text || ''
  return text.replace(/[<>]/g, function(match) {
    const escape = {
      '<': '&lt;',
      '>': '&gt;',
    };
    return escape[match];
  });
}